module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAAkklEQVQYV03MMU4CUBAE0DdHoLUwhtB6Be25BZUJiZUVBZGEgsbSmGijp4DacARaCmNhyRWWfPMhbLe7byZVtcEeqyR/LqaqrjDDKFX1hXt84jXJodmqGuARE3w3OMQTxvjAWy+d4gFrvKSnr/GMO7x32NAWiyS//7DjG8x7czu1pmWSn7acYce37dmz8yS7U9ERcfUtd53yMKUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/downArrow.png
// module id = QZz5
// module chunks = 2